import { createContext } from 'react';

import {
  NozomiEventConfiguration,
  RiskItem,
  TypeItem,
} from '@totem/components/settings/sections/nozomi/eventConfiguration/types';

interface NozomiEventConfigContext {
  loading: boolean;
  action: string;
  actionExtras: string;
  onAction: (newAction: string, extras: string) => void;
  data: NozomiEventConfiguration;
  setData: (newData: NozomiEventConfiguration) => void;
  updateRisk: (old: RiskItem, newValue: RiskItem) => void;
  updateType: (old: TypeItem, newValue: TypeItem) => void;
  updateTypeByIndex: (index: number, newValue: TypeItem) => void;
  hasChanges: boolean;
}

export default createContext<NozomiEventConfigContext>({
  loading: true,
  action: '',
  actionExtras: '',
  onAction: () => {},
  data: null,
  setData: () => {},
  updateRisk: () => {},
  updateType: () => {},
  updateTypeByIndex: () => {},
  hasChanges: false,
});
